import { css, Global } from '@emotion/react';
import PropTypes from 'prop-types';
import Dialog from '../Dialog';
import useMessageService from '../../services/i18n/useMessageService';
import CancelButton from '../CancelButton';

const propTypes = {
    captchaWidget: PropTypes.node,
    error: PropTypes.bool,
    onCancel: PropTypes.func,
    show: PropTypes.bool,
};

const CaptchaVerificationDialog = ({ show, captchaWidget, onCancel, error }) => {
    const [
        [
            verifyCaptchaPagePrompt,
            verifyCaptchaPageTitle,
            verifyCaptchaErrorTitle,
            verifyCaptchaErrorContent,
            cancelLabel,
            closeLabel,
        ],
    ] = useMessageService([
        'captcha.verification_page_content',
        'captcha.verification_page_title',
        'captcha.error_title',
        'captcha.error_content',
        'general.cancel',
        'general.close',
    ]);

    return (
        <>
            {!show && (
                /**
                 * Prevent dialog from stopping the body from scrolling when dialog is open.
                 * In our case, the dialog is always open, but is hidden so the captcha
                 * widget can solve in the background.
                 */
                <Global
                    styles={css`
                        body.body-scrollbar-off {
                            overflow: auto !important;
                        }
                    `}
                />
            )}
            <Dialog
                open
                title={error ? verifyCaptchaErrorTitle : verifyCaptchaPageTitle}
                size="sm"
                focusTrapOptions={{ disabled: !show }}
                overlayProps={{
                    css: css`
                        visibility: ${show ? 'visible' : 'hidden'};
                    `,
                }}
                actions={[
                    <div
                        key="close"
                        css={css`
                            margin-top: 1rem;
                        `}
                    >
                        <CancelButton
                            variant="ghost"
                            onClick={onCancel}
                            label={error ? closeLabel : cancelLabel}
                        />
                    </div>,
                ]}
                css={css`
                    & > div {
                        margin: 0;
                    }
                `}
            >
                <div
                    css={css`
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        gap: 0.5rem;
                    `}
                >
                    <p
                        css={css`
                            font-size: 1.1667rem;
                            margin: 0;
                        `}
                    >
                        {error ? verifyCaptchaErrorContent : verifyCaptchaPagePrompt}
                    </p>
                    <div
                        css={css`
                            width: 100%;
                        `}
                        hidden={error}
                    >
                        {captchaWidget}
                    </div>
                </div>
            </Dialog>
        </>
    );
};

CaptchaVerificationDialog.propTypes = propTypes;

export default CaptchaVerificationDialog;
